import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useAppStatisticModel } from "../appStatisticModel";

export function AppStatistic() {
    const {
        loadData,
        resetState,
    } = useAppStatisticModel()
    useEffect(() => {
        loadData({ pageNum: 1 }).then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

